export default __webpack_public_path__ + "static/media/mr501sid.8b9e2455.png";